import React from "react";
import UserActivityList from "./components/activityList";

export default function HomePage() {
  return (
    <UserActivityList />
  );
}
